/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { getTypedKeys } from "~/tools";
import { GoogleJsonData, FormData } from "./types";

export function isJson(file: File) {
  return file.type === "application/json";
}

export function snakeToCamel(str: string) {
  return str.replaceAll(/([_-][a-z])/g, (group) =>
    group.toUpperCase().replace("-", "").replace("_", "")
  );
}

export function prepareData(data: GoogleJsonData) {
  return getTypedKeys(data).reduce((acc, curr) => {
    return {
      ...acc,
      [snakeToCamel(curr)]: data[curr],
    };
    // Auto-fix changes return type of a function to `string` which is wrong
    // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
  }, {} as FormData);
}

export function hasFiles(list: FileList): boolean {
  return list.length > 0;
}
